import React from "react";
import "../../../assets/css/gcstudent/blogcard/BlogCard.css";

const BlogCard = ({ image, category, title, excerpt, author, date, onClick }) => {
  return (
    <div className="gcStudent-blog-card" onClick={onClick}>
      {/* Cover Image */}
      <div className="gcStudent-blog-card-img-wrapper">
        <img
          src={image}
          alt={title}
          className="gcStudent-blog-card-img"
        />
      </div>

      {/* Card Body */}
      <div className="gcStudent-blog-card-body">
        {/* Category Badge */}
        <span className="gcStudent-blog-card-badge">{category}</span>

        {/* Title */}
        <h4 className="gcStudent-blog-card-title">{title}</h4>

        {/* Excerpt */}
        <p className="gcStudent-blog-card-excerpt">{excerpt}</p>

        {/* Meta — author & date */}
        <p className="gcStudent-blog-card-meta">
          {author}&nbsp;&bull;&nbsp;{date}
        </p>
      </div>
    </div>
  );
};

export default BlogCard;